import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromModule from './reducers/module.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ModuleEffects } from './effects/module.effects';
import * as fromModuleFilter from './reducers/module-filter.reducer';
import { ModuleFilterEffects } from './effects/module-filter.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('module', fromModule.reducer),
    EffectsModule.forFeature([ModuleEffects, ModuleFilterEffects]),
    StoreModule.forFeature('moduleFilter', fromModuleFilter.reducer),
  ]
})
export class ModuleModule { }
